import styled from "styled-components";
import { devices } from "../../Theme.css";

export const UserNameSpan = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: black;
`;
export const SkeletonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;
export const BoxNameTitleContainer = styled.div`
  width: 100%;
 `

/** Mobile */

export const MobileHeader = styled.div`
  @media ${devices.max_sm} {
    display: initial;
  }

  display: none;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: ${({ theme }) => theme?.height?.header ?? "100px"};
  width: 100%;
  background: #ffffff;
  box-shadow: 1px 1px 6px rgb(64 26 15 / 25%);
  z-index: ${({ theme }) => theme?.zIndex?.header ?? 1000};

  .mobile-logo {
    width: 10%;

    img {
      margin-left: 5%;
    }
  }
  .page-title {
    width: fit-content;
    /* width: 80%; */
    color: #000;
    text-align: center;

    /* Headline 5 */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140.5%; /* 19.67px */
  }

  .search-button {
    width: 10%;
    display: flex;
    flex-direction: row;
    align-items: center;

    button:first-child {
      margin-right: 5%;
    }
  }

  .hamburger {
    width: 100%;

    button {
      padding: 12px;
      margin-left: 15px;
    }
  }
`;

export const MobileHeaderLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
`;

export const MobileDetailsViewLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
`;

export const AddMemberText = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140.5%; /* 19.67px */
  color: #000; /* 19.67px */
  margin-left: 5px;
`;

export const AddMemberButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProfileImage = styled.img`
  height: 50px;
  max-height: 50px;
  max-width: 50px;
  width: 50px;
  border-radius: 100%;
  object-fit: cover;
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  width: auto;
  height: ${({ theme }) => theme?.height?.header ?? "88px"};
  background-color: white;
  top: 0px;
  left: 8px;
  right: 8px;
  z-index: 1010;
  border-radius: 0px 0px 40px 40px;
  box-shadow: 1px 1px 6px 0px #401a0f40;

  /** layout */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 32px;
  padding-right: 32px;

  .header-upgrade-text-short {
    display: none;
  }

  .header-upgrade-icon {
    display: none;
  }

  .logo-container {
    width: 200px;
    img {
      width: 100%;
    }
  }

  .column {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .first-column {
  }

  .second-column {
    @media ${devices.md} {
       justify-content: flex-end;
    }
  }

  .input-and-search-results-container {
    width: 50%;
  }

  .profile-container {
    margin-left: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
    gap: 14px;

    svg.bell {
      width: 25px;
      height: 25px;
    }

    .header-upgrade-wrap {
      flex-shrink: 0;
    }

    .box-notification {
      flex-shrink: 0;
    }

    @media ${devices.md} {
      .box-notification svg {
        margin-right: 0;
      }
    }

    @media ${devices.max_sm} {
      width: 100%;
    }
  }

  .hamburger-menu {
    display: none;
  }

  /* Mobile: logo + actions on first row, full-width search on second row */
  &.header-mobile-stack {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    height: auto;
    min-height: ${({ theme }) => theme?.height?.header ?? "100px"};
    padding: 12px 14px 16px;
    gap: 12px;
    border-radius: 0;

    .header-mobile-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
      flex-shrink: 0;
    }

    .header-mobile-actions {
      flex: 1;
      min-width: 0;
      display: flex;
      justify-content: flex-end;
    }

    .header-mobile-search {
      width: 100%;
      flex-shrink: 0;
    }

    .header-mobile-search:empty {
      display: none;
    }

    .first-column {
      width: auto;
      flex: 0 1 auto;
      min-width: 0;
      height: auto;
    }

    .logo-container {
      width: auto;
      max-width: 140px;
      img {
        width: 100%;
        max-width: 140px;
      }
    }

    .input-and-search-results-container {
      width: 100%;
      display: block;
      align-items: stretch;
    }

    .profile-container {
      margin-left: 0;
      width: 100%;
      justify-content: flex-end;
      gap: 12px;
      flex-wrap: nowrap;
    }

    .header-upgrade-wrap {
      flex-shrink: 0;
      margin-right: 0;
    }

    .header-upgrade-btn {
      min-height: 44px;
      padding-left: 12px;
      padding-right: 12px;
    }

    .header-upgrade-text-full {
      display: none;
    }

    .header-upgrade-text-short {
      display: inline;
    }

    @media ${devices.max_xs} {
      .header-upgrade-text-short {
        display: none;
      }
      .header-upgrade-icon {
        display: inline-flex;
      }
      .header-upgrade-btn {
        padding-left: 0;
        padding-right: 0;
        width: 44px;
        min-width: 44px;
        justify-content: center;
      }
    }

    .box-notification {
      flex-shrink: 0;
    }

    .header-notification-trigger {
      min-width: 44px;
      min-height: 44px;
      padding: 8px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .hamburger-menu {
      display: block;
      flex-shrink: 0;
    }

    .header-hamburger-trigger {
      min-width: 44px;
      min-height: 44px;
      padding: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: transparent;
      cursor: pointer;
      border-radius: 8px;
    }

    .header-hamburger-trigger:focus-visible {
      outline: 2px solid ${({ theme }) => theme?.color?.primary ?? "#ee5a29"};
      outline-offset: 2px;
    }

    .profile-menu {
      display: none;
    }
  }

  @media ${devices.max_sm} {
    left: 0;
    right: 0;

    .seach-result {
      position: absolute;
      top: 0px;
      left: -500px;
    }

    .hamburger-menu {
      display: block;
    }
    .profile-menu {
      display: none;
    }

    &:not(.header-mobile-stack) .second-column {
      width: 50%;
      padding-left: 8px;
      justify-content: flex-end;
    }

    &:not(.header-mobile-stack) .input-and-search-results-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    &:not(.header-mobile-stack) .first-column {
      width: 20%;
      padding-right: 4px;
    }

    &:not(.header-mobile-stack) {
      padding-left: 8px;
      padding-right: 8px;
      border-radius: 0px;
    }

    .search-loading {
      position: absolute;
      border-radius: 26px;
      top: 500px;
      left: 0px;
      width: 100%;
    }
  }
`;

export const SearchResultStyle = styled.div`
  position: absolute;
  border-radius: 40px;
  box-shadow: 1px 1px 6px 0px #401a0f40;
  background-color: white;

  @media ${devices.max_sm} {
    width: 100vw;
    top: 154px;
    left: 0px;
    overflow: scroll;
    border-radius: 0px;
  }
`;

export const Input = styled.div<{ $isToggled?: boolean }>`
  width: 100%;
  border-radius: 100px;
  overflow: hidden;
  background-color: #eee;
  display: flex;
  flex-direction: row;
  align-items: center;

  .search-icon {
    transform: translateY(10%);
  }

  .icon-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .input {
    width: 100%;
    height: 100%;
    height: 40px;
    padding-left: 12px;
    background: transparent;
    outline: none;
  }

  @media ${devices.max_sm} {
    ${(props) =>
      props.$isToggled
        ? `
       width: 100%;
       padding-left: 10px;
       padding-right: 10px;
      `
        : `
        width: 16px;
        padding-left: 0px;
        padding-right: 0px;
        background-color: white;
      `}
    transition: 0.5s;
    .icon-container {
      padding-left: 0px;
      padding-right: 0px;
    }

    .second-column {
      display: flex;
      justify-content: space-around;
    }
  }
`;

export const Menu = styled.div`
  /* width: 400px;
  height: 838px; */
  position: relative;
  overflow: hidden;
  overflow: scroll;
  height: max-content;
  max-height: 50vh;
`;

export const MenuList = styled.ul`
  background-color: white;
  list-style: none;
  margin: 0;
  padding: 0;

  .search-loading-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 24px;
    width: 100%;
    box-sizing: border-box;
  }

  .search-loading-label {
    margin: 0 0 12px 0;
    font-size: 14px;
    color: #666;
  }
`;

export const MenuItem = styled.li`
  border-bottom: 1px solid #eee;
  align-items: center;
  padding-right: 24px;
  padding-left: 24px;
  .inner-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 24px;
  }

  :hover {
    background-color: #eee;
  }
`;

export const NotificationDropdown = styled(MenuList)`
  svg.icon {
    display: none;
    width: 10px;
    height: 10px;
  }

  &.notification-dropdown {
    max-height: 355px;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 1px 1px 6px rgba(64, 26, 15, 0.25);
    border-radius: 40px;
    border: 0;
    padding: 0;
    .no-notify {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      height: 300px;
      text-align: center;
      &__bell {
        width: 144px;
        height: 144px;
        opacity: 0.3;
      }
      &__text {
        margin-top: 32px;
        font-weight: 700;
        font-size: 18px;
      }
      &__text_sub {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .chakra-menu__menuitem {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    position: relative;
    background: #fff;
    border-bottom: 1px solid #d1d1d1;
    padding: 16px 35px 16px 24px;
    &:hover {
      background: #e2e1e1 !important;
    }
    &.unreading {
      background: #eee;
    }
    &:last-child {
      border-bottom: 0;
    }
    .box-txt {
      color: #000;
      .txt {
        font-weight: 500;
        font-size: 14px;
        line-height: calc(17 / 14);
      }
      .date {
        font-size: 12px;
      }
    }
    .box-icon {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translate(0, -50%);
      font-size: 22px;
    }
  }
`;
export const TextBadgeContainer = styled.div<{
  $isVisible?: boolean | 0 | undefined;
}>`
  display: ${(props) => (props.$isVisible ? "block" : "none")};
  position: relative;
  bottom: 40px;
  left: 10px;
`;
